import * as sharedStyles from './style.module.css';
const colors = {
    base: sharedStyles.colorBase,
    subtle: sharedStyles.colorSubtle,
    subdued: sharedStyles.colorSubdued,
    inverted: sharedStyles.colorInverted,
    negative: sharedStyles.colorNegative,
    warning: sharedStyles.colorWarning,
    positive: sharedStyles.colorPositive,
    disabled: sharedStyles.colorDisabled,
    'urgency-medium': sharedStyles.colorUrgencyMedium,
    'urgency-high': sharedStyles.colorUrgencyHigh,
};
export default colors;
//# sourceMappingURL=colors.js.map